import type { WorkspaceSearchResultType } from "@/pages/workspace/components/content-search/ResultTypeSwitch";

export interface WorkspaceSearchView {
  resultType: WorkspaceSearchResultType;
  zoomedWorkspaceId: string | null;
  /** The view the zoom was opened from; only meaningful while zoomed. */
  zoomedFrom: WorkspaceSearchResultType;
}

/**
 * Zooming into a workspace ("Vis alle N i workspacet") opens the documents view on that
 * one workspace; leaving the zoom ("Alle workspaces", null) returns to the view it was
 * opened from, "Alle" or "Dokumenter", rather than always to "Dokumenter".
 */
export const zoomWorkspaceSearch = (
  view: WorkspaceSearchView,
  workspaceId: string | null
): WorkspaceSearchView => {
  if (workspaceId === null) {
    return {
      resultType: view.zoomedWorkspaceId ? view.zoomedFrom : view.resultType,
      zoomedWorkspaceId: null,
      zoomedFrom: "documents",
    };
  }
  return {
    resultType: "documents",
    zoomedWorkspaceId: workspaceId,
    zoomedFrom: view.zoomedWorkspaceId ? view.zoomedFrom : view.resultType,
  };
};
